import { CancelButton, SaveButton } from '@core/components/Buttons';
import { FormDialogContent, SimpleDialog } from '@core/components/Dialog';
import { DateInput } from '@core/components/Inputs';
import { SimpleTable } from '@core/components/Table';
import { useApiUtils } from '@core/util/apiUtils';
import { DataBR } from '@format';
import { Grid } from '@material-ui/core';
import { InputMonetario } from 'app/components/Input';
import SelectConta from 'app/components/Select/SelectConta';
import transferenciaApi from 'app/services/api/transferenciaApi';
import * as Actions from 'app/store/actions';
import { getCurrency } from 'app/utils/monetarioUtil';
import { FormikProvider, useFormik } from 'formik';
import React, { useContext, useEffect, useState } from 'react';
import { BiTransfer } from 'react-icons/bi';
import { useDispatch } from 'react-redux';
import { ConciliacaoContext } from '../../ConciliacaoContext';
import { ConciliacaoModal } from '../../modal/ConciliacaoModal';

const PesquisaTransferenciaModal = ({ setFormularioTransferencia }) => {
  const [transferencias, setTransferencias] = useState([]);
  const [selecao, setSelecao] = useContext(ConciliacaoContext).selecao;
  const [totalElements, setTotalElements] = useContext(ConciliacaoContext).totalElements;
  const [, setPage] = useContext(ConciliacaoContext).page;
  const [, setSize] = useContext(ConciliacaoContext).size;
  const [, setSort] = useContext(ConciliacaoContext).sort;
  const [loading, setLoading] = useContext(ConciliacaoContext).loading;
  const [modal, setModal] = useContext(ConciliacaoContext).modal;
  const [extratoSelecionado, setExtratoSelecionado] = useContext(ConciliacaoContext).extratoSelecionado;

  const [conciliacoes, setConciliacoes] = useContext(ConciliacaoContext).conciliacoes;

  const dispatch = useDispatch();
  const apiUtils = useApiUtils(dispatch, Actions);

  const showMessage = (message, variant) => {
    dispatch(
      Actions.showMessage({
        message,
        variant,
      })
    );
  };

  useEffect(() => {
    const permiteSelecaoSoDeUmaTransferencia = () => {
      if (selecao.length > 1) {
        selecao.shift();
        setSelecao([...selecao]);
      }
    };

    permiteSelecaoSoDeUmaTransferencia();
  }, [selecao, setSelecao]);

  const initialPage = {
    destino: '',
    origem: '',
    valor: '',
    data: undefined,
    page: 0,
    query: '',
    size: 15,
    sort: 'data,DESC',
  };

  const formik = useFormik({
    initialValues: initialPage,
    onSubmit: () => {},
    validateOnChange: true,
  });

  useEffect(() => {
    fetchTransferencias({
      ...formik.values,
      contaDestinoId: formik.values?.destino?.id,
      contaOrigemId: formik.values?.origem?.id,
      data: formik.values?.data?.format('YYYY-MM-DD'),
    });
    // Efeito de montagem: roda uma única vez. Incluir as dependências reexecutaria a carga
    // inicial a cada render (loop de chamadas à API).
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const valuesDestino = formik?.values?.destino;
  const valuesOrigem = formik?.values?.origem;
  const valuesValor = formik?.values?.valor;
  const valuesData = formik?.values?.data;
  useEffect(() => {
    fetchTransferencias({
      ...formik.values,
      contaDestinoId: formik.values?.destino?.id,
      contaOrigemId: formik.values?.origem?.id,
      data: formik.values?.data?.format('YYYY-MM-DD'),
    });
    // A função é recriada a cada render; incluí-la reexecutaria a busca em loop.
    // O efeito depende apenas do gatilho listado.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [valuesDestino, valuesOrigem, valuesValor, valuesData]);

  const fetchTransferencias = async (search = initialPage) => {
    setLoading(true);

    try {
      const response = await transferenciaApi().buscarTodas(search);

      if (response?.status === 200) {
        const transferenciasNaoConciliadas = response?.data?.content.filter(
          (transferencia) => transferencia.conciliado === false
        );

        setTransferencias(transferenciasNaoConciliadas);
        setTotalElements(response.data.totalElements);
      }
    } catch (err) {
      apiUtils.handleApiError(err);
    } finally {
      setLoading(false);
    }
  };

  const carregaTransferenciaNoCard = () => {
    // Adicionar transferência no formulário
    setFormularioTransferencia({
      ...extratoSelecionado.transferenciaBancaria,
      contaOrigem: {
        id: extratoSelecionado.transferenciaBancaria.origem.id,
        descricao: extratoSelecionado.transferenciaBancaria.origem.descricao,
      },
      contaDestino: {
        id: extratoSelecionado.transferenciaBancaria.destino.id,
        descricao: extratoSelecionado.transferenciaBancaria.destino.descricao,
      },
    });

    // Adicionar transferência na lista de conciliações
    setModal('');
    conciliacoes
      .filter((c) => c.id === extratoSelecionado.id)
      .forEach((c) => {
        c.transferenciaBancaria = extratoSelecionado.transferenciaBancaria;
        c.criarTransferencia = false;
      });
    setConciliacoes(conciliacoes);
    setExtratoSelecionado({});
  };

  const vincularContasComExtrato = () => {
    setLoading(true);

    if (selecao?.length === 1 && Math.abs(selecao[0].valor) === Math.abs(extratoSelecionado?.valor)) {
      const tipoLancamento = extratoSelecionado.tipoLancamentoConciliacao;

      const destino = extratoSelecionado?.transferenciaBancariaForm?.destinoId === selecao[0]?.destinoId;
      const origem = extratoSelecionado?.transferenciaBancariaForm?.origemId === selecao[0]?.origemId;

      if (
        (tipoLancamento === 'RECEITA' && destino) ||
        (tipoLancamento === 'DESPESA' && origem) ||
        (tipoLancamento === 'TRANSFERENCIA' && destino) ||
        (tipoLancamento === 'TRANSFERENCIA' && origem)
      ) {
        adicionarDespesaNoExtrato(selecao[0]);
      } else {
        showMessage('Conta (origem ou destino) é diferente da conta do extrato.', 'error');
      }
    } else {
      showMessage('O valor da transferência selecionada está diferente do valor do extrato.', 'error');
    }

    setLoading(false);
  };

  const adicionarDespesaNoExtrato = (transferencia) => {
    if (transferencia) {
      const novoExtrato = {
        ...extratoSelecionado,
        transferenciaBancaria: {
          ...transferencia,
          destino: { id: transferencia.destinoId, descricao: transferencia.destino },
          origem: { id: transferencia.origemId, descricao: transferencia.origem },
        },
      };
      extratoSelecionado.transferenciaBancaria = {
        ...transferencia,
        destino: { id: transferencia.destinoId, descricao: transferencia.destino },
        origem: { id: transferencia.origemId, descricao: transferencia.origem },
      };
      setExtratoSelecionado({ ...novoExtrato });
    }
    carregaTransferenciaNoCard();
  };

  const close = () => {
    formik.setValues({});
    setModal('');
  };

  const getSomatorioSelecao = () => {
    let total = 0;
    if (selecao) {
      selecao.forEach((transferencia) => {
        total += transferencia.valor;
      });
    }
    return total;
  };

  const getValorDiferenca = () => {
    const somatorioSelecionados = getSomatorioSelecao() || 0;
    return Math.abs(extratoSelecionado?.valor) - somatorioSelecionados;
  };

  const footerTable = (
    <div>
      <div style={{ padding: '12px 0 0 24px', fontWeight: 'bold' }}>
        Valor total do extrato (R$):
        {new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' })
          .format(Math.abs(extratoSelecionado?.valor))
          .replace('R$', '')}
      </div>
      <div style={{ padding: '12px 0 0 24px', fontWeight: 'bold' }}>
        Valor da transferência selecionada (R$):
        {new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' })
          .format(getSomatorioSelecao())
          .replace('R$', '')}
      </div>
      <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'end' }}>
        <div style={{ padding: '12px 0 0 24px', fontWeight: 'bold' }}>Valor da diferença (R$):</div>
        <div style={{ color: 'red', fontWeight: 'bold', marginLeft: 2 }}>
          {new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' })
            .format(getValorDiferenca())
            .replace('R$', '')}
        </div>
      </div>
    </div>
  );

  const columns = [
    {
      name: 'origem.descricao',
      title: 'Conta origem',
      align: 'left',
      sortingEnabled: true,
      getCellValue: (transferencia) => transferencia?.origem,
    },
    {
      name: 'destino.descricao',
      title: 'Conta destino',
      align: 'left',
      sortingEnabled: true,
      getCellValue: (transferencia) => transferencia?.destino,
    },
    {
      name: 'valor',
      title: 'Valor (R$)',
      align: 'right',
      sortingEnabled: true,
      getCellValue: (transferencia) => getCurrency(transferencia?.valor),
    },
    {
      name: 'data',
      title: 'Data',
      align: 'center',
      sortingEnabled: true,
      getCellValue: (transferencia) => DataBR(transferencia?.data),
    },
    {
      name: 'descricao',
      title: 'Descrição',
      align: 'left',
      sortingEnabled: false,
      getCellValue: (transferencia) => transferencia?.descricao,
    },
  ];

  const _errors = {
    origem: (formik.submitCount > 0 || formik.touched?.origem) && formik.errors?.origem,
    destino: (formik.submitCount > 0 || formik.touched?.destino) && formik.errors?.destino,
    valor: (formik.submitCount > 0 || formik.touched?.valor) && formik.errors?.valor,
    data: (formik.submitCount > 0 || formik.touched?.data) && formik.errors?.data,
  };

  return (
    <>
      <SimpleDialog fullScreen open={modal === ConciliacaoModal.pesquisaTransferencia} onClose={close} innerScroll>
        <FormikProvider value={formik}>
          <FormDialogContent
            onSubmit={async (e) => {
              vincularContasComExtrato();
            }}
            fullScreen
            header={{
              title: 'Buscar transferência',
              icon: <BiTransfer />,
              toolbar: (
                <>
                  <CancelButton title="cancelar" type="button" onClick={close}>
                    Cancelar
                  </CancelButton>
                  <SaveButton color="buttonSave" type="submit" styles={undefined} variant={'contained'}>
                    Selecionar
                  </SaveButton>
                </>
              ),
            }}
            content={
              <>
                <Grid container style={{ padding: 16 }} spacing={3}>
                  <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                    <SelectConta
                      id="origem"
                      name="origem"
                      label="Conta origem"
                      onChange={formik.handleChange}
                      value={formik.values?.origem || ''}
                      touched={!!_errors?.origem}
                      error={_errors?.origem}
                    />
                  </Grid>

                  <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                    <SelectConta
                      id="destino"
                      name="destino"
                      label="Conta destino"
                      onChange={formik.handleChange}
                      value={formik.values?.destino || ''}
                      touched={!!_errors?.destino}
                      error={_errors?.destino}
                    />
                  </Grid>

                  <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                    <InputMonetario
                      fullWidth
                      id="valor"
                      label="Valor (R$)"
                      handleChange={formik.handleChange}
                      value={formik.values?.valor}
                      touched={!!_errors.valor}
                      error={_errors.valor}
                      helperText={_errors.valor}
                      maximumValue="999999999.99"
                    />
                  </Grid>

                  <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                    <DateInput
                      fullWidth
                      id="data"
                      label="Data"
                      value={formik.values?.data}
                      onChange={formik.handleChange}
                      error={!!_errors.data}
                      helperText={_errors.data}
                    />
                  </Grid>
                </Grid>
                <Grid container>
                  <SimpleTable
                    hideTopSelection
                    fetchOnCreate={false}
                    defaultSorting={[{ columnName: 'data', direction: 'desc' }]}
                    columns={columns}
                    selection={selecao}
                    onSelectionChange={setSelecao}
                    rows={transferencias}
                    loading={loading}
                    totalCount={totalElements}
                    fetchData={fetchTransferencias}
                    onCurrentPageChange={setPage}
                    onPageSizeChange={setSize}
                    onSortingChange={setSort}
                    footerTable={footerTable}
                  />
                </Grid>
              </>
            }
          />
        </FormikProvider>
      </SimpleDialog>
    </>
  );
};

export default PesquisaTransferenciaModal;
